import { useEffect, useState } from "react";
import { getUserRoleApi } from "../api/predefine.js";
export function useUserRole() {
    const [userRole, setUserRole] = useState();
    const token = window.localStorage.getItem("token");

    useEffect(() => {
        if (token) {
            getUserRole();
        }
    }, [token]);

    const getUserRole = async () => {
        const response = await getUserRoleApi();
        if (response?.data) {
            setUserRole(response.data);
        } else {
            setUserRole("Token Expired");
        }
    };

    return userRole;
}
